import React from 'react';
import './Header.css';
import TopNavBar from '../TopNavBar/TopNavBar';
export default function Header(props) {
    return (
        <div className="headerNavBarContainerSticky">
            <div className="col-md-12 col-lg-12 no-padding" id="headerNavBarContainer">
                <TopNavBar {...props} />
            </div>
        </div>
    )
}